import { render, staticRenderFns } from "./AcceptAccess.vue?vue&type=template&id=cf6af1f0&scoped=true&"
import script from "./AcceptAccess.vue?vue&type=script&lang=ts&"
export * from "./AcceptAccess.vue?vue&type=script&lang=ts&"
import style0 from "./AcceptAccess.vue?vue&type=style&index=0&id=cf6af1f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf6af1f0",
  null
  
)

export default component.exports